"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ApiDocsController", {
    enumerable: true,
    get: function() {
        return ApiDocsController;
    }
});
const _common = require("@nestjs/common");
const _swaggerHtml = /*#__PURE__*/ _interop_require_default(require("./template/swaggerHtml"));
const _redocHtml = /*#__PURE__*/ _interop_require_default(require("./template/redocHtml"));
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _apidocsservice = require("~/services/api-docs/api-docs.service");
const _publicapilimiterguard = require("~/guards/public-api-limiter.guard");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ApiDocsController = class ApiDocsController {
    async swaggerJson(context, baseId, req) {
        const swagger = await this.apiDocsService.swaggerJson(context, {
            baseId: baseId,
            siteUrl: req.ncSiteUrl,
            req
        });
        return swagger;
    }
    async swaggerJsonV2(context, baseId, req) {
        const swagger = await this.apiDocsService.swaggerJsonV2(context, {
            baseId: baseId,
            siteUrl: req.ncSiteUrl,
            req
        });
        return swagger;
    }
    swaggerHtml(baseId, res) {
        res.send((0, _swaggerHtml.default)({
            ncSiteUrl: process.env.NC_PUBLIC_URL || '',
            dashboardPath: _Noco.default.getConfig().dashboardPath || ''
        }));
    }
    redocHtml(baseId, res) {
        res.send((0, _redocHtml.default)({
            ncSiteUrl: process.env.NC_PUBLIC_URL || '',
            dashboardPath: _Noco.default.getConfig().dashboardPath || ''
        }));
    }
    swaggerHtmlV2(baseId, res) {
        res.send((0, _swaggerHtml.default)({
            ncSiteUrl: process.env.NC_PUBLIC_URL || '',
            dashboardPath: _Noco.default.getConfig().dashboardPath || ''
        }));
    }
    redocHtmlV2(baseId, res) {
        res.send((0, _redocHtml.default)({
            ncSiteUrl: process.env.NC_PUBLIC_URL || '',
            dashboardPath: _Noco.default.getConfig().dashboardPath || ''
        }));
    }
    async swaggerJsonV3(context, baseId, req) {
        const swagger = await this.apiDocsService.swaggerJsonV3(context, {
            baseId: baseId,
            siteUrl: req.ncSiteUrl,
            req
        });
        return swagger;
    }
    swaggerHtmlV3(baseId, res) {
        res.send((0, _swaggerHtml.default)({
            ncSiteUrl: process.env.NC_PUBLIC_URL || '',
            dashboardPath: _Noco.default.getConfig().dashboardPath || ''
        }));
    }
    redocHtmlV3(baseId, res) {
        res.send((0, _redocHtml.default)({
            ncSiteUrl: process.env.NC_PUBLIC_URL || '',
            dashboardPath: _Noco.default.getConfig().dashboardPath || ''
        }));
    }
    constructor(apiDocsService){
        this.apiDocsService = apiDocsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/swagger.json'
    ]),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _extractidsmiddleware.Acl)('swaggerJson'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], ApiDocsController.prototype, "swaggerJson", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/meta/bases/:baseId/swagger.json'
    ]),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _extractidsmiddleware.Acl)('swaggerJson'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], ApiDocsController.prototype, "swaggerJsonV2", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/swagger'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    _ts_param(0, (0, _common.Param)('baseId')),
    _ts_param(1, (0, _common.Response)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", void 0)
], ApiDocsController.prototype, "swaggerHtml", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/redoc'
    ]),
    _ts_param(0, (0, _common.Param)('baseId')),
    _ts_param(1, (0, _common.Response)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", void 0)
], ApiDocsController.prototype, "redocHtml", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/meta/bases/:baseId/swagger'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    _ts_param(0, (0, _common.Param)('baseId')),
    _ts_param(1, (0, _common.Response)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", void 0)
], ApiDocsController.prototype, "swaggerHtmlV2", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)([
        '/api/v2/meta/bases/:baseId/redoc'
    ]),
    _ts_param(0, (0, _common.Param)('baseId')),
    _ts_param(1, (0, _common.Response)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", void 0)
], ApiDocsController.prototype, "redocHtmlV2", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v3/meta/bases/:baseId/swagger.json'
    ]),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _extractidsmiddleware.Acl)('swaggerJson'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], ApiDocsController.prototype, "swaggerJsonV3", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v3/meta/bases/:baseId/swagger'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    _ts_param(0, (0, _common.Param)('baseId')),
    _ts_param(1, (0, _common.Response)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", void 0)
], ApiDocsController.prototype, "swaggerHtmlV3", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)([
        '/api/v3/meta/bases/:baseId/redoc'
    ]),
    _ts_param(0, (0, _common.Param)('baseId')),
    _ts_param(1, (0, _common.Response)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", void 0)
], ApiDocsController.prototype, "redocHtmlV3", null);
ApiDocsController = _ts_decorate([
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apidocsservice.ApiDocsService === "undefined" ? Object : _apidocsservice.ApiDocsService
    ])
], ApiDocsController);
